<template>
    <v-row
            dense
            class="text-center">
        <v-col
                cols="12"
                dense
                class="text-center">
            <div id="stripe-payment-method" />
        </v-col>
    </v-row>
</template>

<script>
    import {loadStripe} from '@stripe/stripe-js';
    import PaymentTypeModel from "@/models/paymenttype.model";
    import Customer from "@/models/customer.model";
    
    export default {
        name: "StripeMethodComponent",
        props: {
            show: {type: Boolean, default: true},
            config: {type: Object, required: true},
            threeDs: {type: Object, required: true},
            title: {type: String, default: 'Add new payment card'},
            consumer: {type: Customer, required: true}
        },
        data() {
            return {
                initRes: null,
                stripe: null,
                elements: null,
                loading: false,
                value: null,
                isEmpty: true,
                isComplete: false
            }
        },
        computed: {
            account() {
                return this.$store.forms.getAccount();
            },
            appointment() {
                return this.$store.forms.getAppointment();
            }
        },
        watch: {
            loading(value) {
                this.$emit('loading', value)
            },
            show(val) {
                if (val === true) {
                    this.initElement()
                }
            }
        },
        mounted() {
            this.initElement()
        },
        methods: {
            initElement() {
                this.loading = true;
                this.$emit('init');
                this.init3ds().finally(() => {
                    this.loading = false;
                })
            },
            async loadStripe(token) {
                const stripe = await loadStripe(this.config.token);
                const options = {
                    layout: 'tabs',
                    fields: {
                        billingDetails: 'never'
                    }
                };
                const elements = stripe.elements({
                    clientSecret: token
                });
                const payment = elements.create('payment', options);
                payment
                    .on('change', (element) => {
                        this.isEmpty = element.empty
                        this.isComplete = element.complete
                    })
                    .mount('#stripe-payment-method');

                this.elements = elements;
                this.stripe = stripe;
            },
            async init3ds() {
                const res = await this.$services.core.post('3ds/init', {
                    account: this.appointment.account_id,
                    calendar: this.appointment.calendar_id,
                    request: this.appointment.id,
                    // to show all enabled payment methods
                    automatic_payments_methods_enabled: true,
                    // 3ds handled by client
                    handles_3ds: true,
                    first_name: this.consumer.first_name,
                    last_name: this.consumer.last_name,
                    email: this.consumer.email,
                    phone: this.consumer.phone,
                }, {
                    baseURL: this.threeDs.endpoint
                })

                if (res.data.success) {
                    await this.loadStripe(res.data.client_secret);
                    this.initRes = res.data;
                } else {
                    this.$services.modals.alerts.error('System error. Please contact support.');
                }
            },
            async confirmSetup() {
                const confirmResponse = await this.stripe.confirmSetup({
                    elements: this.elements,
                    confirmParams: {
                        return_url: this.initRes.return_url,
                        payment_method_data: {
                            billing_details: {
                                name:  this.consumer.fullName,
                                email: this.consumer.email,
                                phone: this.consumer.phone,
                                address: {
                                    city: null,
                                    country: null,
                                    line1: null,
                                    line2: null,
                                    postal_code: null,
                                    state: null
                                },
                            }
                        }
                    },
                    redirect: 'if_required'
                });

                if (confirmResponse.setupIntent) {
                    if (confirmResponse.setupIntent.status === 'succeeded') {
                        const finishRes = await this.$services.core.post('3ds/finish', this.initRes, {
                            baseURL: this.threeDs.endpoint
                        });
                        if (finishRes.data.success) {
                            this.value = new PaymentTypeModel({
                                type: 'stripe',
                                name: finishRes.data.details.brand + ' ' + finishRes.data.details.last4,
                                token: finishRes.data.token,
                                brand: finishRes.data.details.brand,
                                last4: finishRes.data.details.last4,
                                exp: {
                                    year: finishRes.data.details.expire_year,
                                    month: finishRes.data.details.expire_month,
                                }
                            });

                            return this.value;
                        } else {
                            this.$services.modals.alerts.error('System error. Try again or contact support');
                        }
                    } else {
                        this.$services.modals.alerts.error('System error. Try again or contact support');
                    }
                }

                if (confirmResponse.error) {
                    this.$services.modals.alerts.error(confirmResponse.error.message);
                }
            },
            async submit() {
                this.value = null;
                if (this.isComplete) {
                    this.loading = true;
                    await this.confirmSetup()
                    this.loading = false;
                } else {
                    this.$services.modals.alerts.error('Invalid card details');
                }

                return this.value;
            }
        }
    }
</script>
<style>
.question-payment-method-item {
  border: solid 1px rgba(0, 0, 0, 0.12);
  padding: 14px 7px;
}
.question-payment-method-item label {
  display: block !important;
}
</style>